module.exports = __webpack_public_path__ + "img/horse_placeholder2.9a70dc5d.jpg";